import "rxjs/add/operator/mergeMap";
import { Creators, Types } from "../reducer";
import { isBoolean, values } from "lodash";
import papaparse from "papaparse";
import { saveAs } from "file-saver";
import moment from "moment";

import * as firebase from "firebase";
import { states } from "../../common/utils";

export default (action$) =>
  action$.ofType(Types.EXPORT_CUSTOMER).mergeMap(
    (action) =>
      new Promise((resolve, reject) => {
        // download customer data to client then export to csv format
        const listenerRef = firebase.database().ref("customers");

        listenerRef.once("value").then((snapshot) => {
          let customers = values(snapshot.val());
          customers = customers = customers.filter((c) => !!c.created);
          customers.sort((a, b) => b.created - a.created);

          const {
            filters: { country, state, isMember, membershipType },
            locations,
          } = action;

          customers = customers.filter((c) => {
            const customerCountry = (c.country || "").toLowerCase();
            const customerProvince = (c.province || "").toLowerCase();
            const customerMembershipType = (c.type || "").toLowerCase();
            let stateName = "";
            if (state) {
              stateName = states
                .find((_) => _.value === state)
                .label.toLowerCase();
            }

            return (
              (country ? customerCountry === country.toLowerCase() : true) &&
              (state
                ? customerProvince === state.toLowerCase() ||
                  customerProvince === stateName
                : true) &&
              (isBoolean(isMember)
                ? c.member === isMember || !c.isMember
                : true) &&
              (membershipType
                ? customerMembershipType === membershipType.toLowerCase()
                : true)
            );
          });

          const locationsNames = Object.keys(locations);

          customers = customers.map((c) => {
            const { signIns = {} } = c;
            const signInsWithDefault = {
              ...locationsNames.reduce((acc, k) => ({ ...acc, [k]: {} }), {}),
              ...signIns,
            };
            const signInsReportValues = Object.keys(signInsWithDefault).reduce(
              (acc, key) => {
                const ranges = signInsWithDefault[key];
                const locationSignIns = Object.keys(ranges).reduce(
                  (acc, key) => [
                    ...Object.values(ranges[key]).map((_) =>
                      moment(_.checkInAt)
                    ),
                    ...acc,
                  ],
                  []
                );
                let lastSignIn = "N/A";
                if (locationSignIns.length > 0) {
                  lastSignIn = moment
                    .max(locationSignIns)
                    .format("M/D/YYYY h:mm a");
                }
                return {
                  ...acc,
                  [`Total signins ${key}`]: locationSignIns.length,
                  [`Last sign in ${key}`]: lastSignIn,
                };
              },
              {}
            );
            return {
              Email: c.email,
              "First name": c.firstName,
              "Last name": c.lastName,
              "Id number": c.idNumber,
              "Id type": c.idType,
              "Date of birth":
                c.dateOfBirth &&
                c.dateOfBirth.month &&
                c.dateOfBirth.day &&
                c.dateOfBirth.year
                  ? `${c.dateOfBirth.month}/${c.dateOfBirth.day}/${c.dateOfBirth.year}`
                  : "",
              Address: c.address,
              Address2: c.address2,
              City: c.city,
              Province: c.province,
              Country: c.country,
              Location: c.location,
              Postal: c.postal,
              Phone: c.phone,
              Member: c.member,
              "Membership type": c.type,
              "Created time": moment(c.created).format("M/D/YYYY h:mm a"),
              "Updated time": moment(c.updated).format("M/D/YYYY h:mm a"),
              ...(Object.keys(signInsReportValues).length > 0
                ? signInsReportValues
                : {}),
            };
          });

          const csv = papaparse.unparse(customers, { header: true });
          const fileData = [csv];

          var file = new File(fileData, "customers.csv", {
            type: "text/csv;charset=utf-8",
          });
          saveAs(file);
          resolve(Creators.exportCustomerSucceeded());
        });
      })
  );



// WEBPACK FOOTER //
// ./src/customer/epics/exportCustomer.js